<script>
import {
    eventGroupState
} from '@app/store/eventGroupStore.js';
import {
    projectState
} from '@app/store/projectStore.js';
import {
    historyState
} from '@app/store/historyStore.js';

const alignLeft = () => {
    if (!quillEditor){
        return;
    }
    
    quillEditor.setSelection(0, quillEditor.getLength());
    quillEditor.format('align', false);

    $eventGroupState[$projectState.selected].selected.forEach(eventIndex => {
        $eventGroupState[$projectState.selected].events[eventIndex].alignment = "left";
    });

    historyState.insert({
        name: "align left", //action name
        eventGroup: $projectState.selected,
        snapshots: [{
            store: "eventGroupState",
            value: JSON.stringify($eventGroupState)
        }]
    });
}
</script>

<li class="nav-item" title="Align Left" >
    <a 
        class="nav-link" 
        href="#!/" 
        id="align-left-btn"
        role="button"
        aria-label="Align text left"
        aria-disabled={!$eventGroupState[$projectState.selected] || $eventGroupState[$projectState.selected].selected.length === 0}
        on:click={alignLeft} 
        class:disabled={!$eventGroupState[$projectState.selected] || $eventGroupState[$projectState.selected].selected.length === 0}
    ><i class="bi bi-text-left" /></a>
</li>
